import React, { useCallback, useState } from 'react';

const shareDialogInitialState: { opened: boolean; selectedItems: FolderManagerItem[] } = {
  opened: false,
  selectedItems: [],
};

export const useShareDialog = () => {
  const [shareDialogState, setShareDialogState] = useState(shareDialogInitialState);

  const openDialog = useCallback((selectedItems: FolderManagerItem[]) => {
    setShareDialogState({
      selectedItems: selectedItems,
      opened: true,
    });
  }, []);

  const closeDialog = useCallback(() => {
    setShareDialogState({
      selectedItems: [],
      opened: false,
    });
  }, []);

  return {
    shareDialogState,
    openShareDialog: openDialog,
    closeShareDialog: closeDialog,
  };
};
